import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject,  Input, OnInit } from '@angular/core';
import { ALAIN_I18N_TOKEN, SettingsService } from '@delon/theme';

import { InputBoolean } from '@delon/util';
import { EnvironmentService } from '../../services/environment.service';
import { I18nClientService } from '../services/i18n-client.service';
import { I18NService } from '../services/i18n.service';

@Component({
  selector: 'header-i18n',
  template: `
  <a nz-dropdown [nzDropdownMenu]="menu" >
    <div *ngIf="showLangText" nz-dropdown >
        <i nz-icon nzType="global"></i>
      <span class ="languageName"> {{ 'menu.lang' | translate }}</span>
        <i nz-icon nzType="down" class="pl"></i>
      </div>
      <i *ngIf="!showLangText" nz-dropdown nz-icon nzType="global" ></i>
    </a>
    <nz-dropdown-menu  #menu="nzDropdownMenu" nzPlacement="right">
      <ul nz-menu>
        <li nz-menu-item
          *ngFor="let item of languages"
          [nzSelected]="item.code === curLangCode"
          (click)="change(item.code)">
          <span role="img" [attr.aria-label]="item.text" class="pr-xs flag-icon" [ngClass]="item.abbr"></span>
          {{ item.text }}
        </li>
      </ul>
    </nz-dropdown-menu>
  `,
  "styles": [`@media (min-width: 320px) and (max-width: 480px) {
    .languageName{
      display: none;
    }
    .pl{
      padding-left:2px
    }
  }
  @media (min-width: 0px) and (max-width: 320px) {
    .languageName{
      display: none;
    }
    .pl{
      padding-left:2px
    }
  }
    `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderI18nComponent implements OnInit {

  /** Whether to display language text */
  @Input() @InputBoolean() showLangText = true;
  languages:any[] = [];
  constructor(
    private settings: SettingsService,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    @Inject(DOCUMENT) private doc: string,
    private i18nClient: I18nClientService,
    private envService: EnvironmentService
  ) { }

  ngOnInit(): void {
    this.i18n.getLanguages().subscribe((langs) => {
      this.languages = langs;
    });
  }

  get curLangCode() {
    return this.settings.layout.lang;
  }

  change(lang: string) {
    this.settings.setLayout('lang', lang);
    this.i18n.use(lang);
    this.i18nClient.loadResource(lang);
  }
}
